import { render } from "./ButtonContactForm.vue?vue&type=template&id=fab82bfc"
const script = {}
script.render = render

export default script